export default __webpack_public_path__ + "static/media/york-logo.bc96a06f.svg";